/* CLYNT theme — shell behaviour.
   Progressive enhancement only: every link in here is reachable without JS. */

(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function strings(key, fallback) {
    return (window.CLYNT_STRINGS && window.CLYNT_STRINGS[key]) || fallback;
  }

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* ------------------------------------------------------------------
     Header cart count
     Every [data-cart-count] shows the live item count. Updated from
     section markup when the cart changes, so there is no second request.
     ------------------------------------------------------------------ */

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function countFromSectionMarkup(markup) {
    if (!markup) return null;
    var parsed = new DOMParser().parseFromString(markup, 'text/html');
    var el = parsed.querySelector('[data-cart-count]');
    return el ? el.textContent.trim() : null;
  }

  function headerSectionId() {
    var header = document.querySelector('[data-header-section]');
    return header ? header.getAttribute('data-header-section') : null;
  }

  /* ------------------------------------------------------------------
     Nested navigation
     The panel already opens on hover and focus through CSS. This adds a
     toggle button for touch and keyboard, Escape, and outside click.
     ------------------------------------------------------------------ */

  function initNavItem(root) {
    var toggle = root.querySelector('[data-nav-toggle]');
    var panel = root.querySelector('[data-nav-panel]');
    if (!toggle || !panel) return;

    function open() {
      root.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }

    function close() {
      root.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    function isOpen() {
      return toggle.getAttribute('aria-expanded') === 'true';
    }

    toggle.addEventListener('click', function () {
      if (isOpen()) {
        close();
      } else {
        open();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) {
        close();
        toggle.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (isOpen() && !root.contains(event.target)) close();
    });

    root.addEventListener('focusout', function (event) {
      if (isOpen() && !root.contains(event.relatedTarget)) close();
    });
  }

  /* ------------------------------------------------------------------
     Mobile drawer
     Locks body scroll, traps focus, returns focus to the trigger.
     ------------------------------------------------------------------ */

  /* Works for any [data-drawer]: the mobile menu, which has a trigger, and
     the cart drawer, which is opened in code. Close buttons are delegated so
     the panel can be replaced wholesale by the Section Rendering API without
     losing its handlers. Returns a controller, or null if the markup is
     incomplete. */
  function initDrawer(drawer) {
    var panel = drawer && drawer.querySelector('[data-drawer-panel]');
    if (!drawer || !panel) return null;

    var opener = drawer.id ? document.querySelector('[aria-controls="' + drawer.id + '"]') : null;
    var lastFocused = null;

    function open() {
      if (isOpen()) return;
      lastFocused = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add('is-drawer-open');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      focusFirst();
    }

    /* Query from the panel element rather than prefixing FOCUSABLE, which is
       a selector list: a prefix would only apply to its first entry. */
    function focusFirst() {
      var first = panel.querySelector(FOCUSABLE);
      if (first) first.focus();
    }

    function close() {
      drawer.hidden = true;
      if (!document.querySelector('[data-drawer]:not([hidden])')) {
        document.body.classList.remove('is-drawer-open');
      }
      if (opener) opener.setAttribute('aria-expanded', 'false');
      if (lastFocused && lastFocused.isConnected) lastFocused.focus();
    }

    function isOpen() {
      return !drawer.hidden;
    }

    if (opener) opener.addEventListener('click', open);

    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-drawer-close]')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!isOpen()) return;

      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key !== 'Tab') return;

      var items = Array.prototype.filter.call(
        panel.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
      if (items.length === 0) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    return { open: open, close: close, isOpen: isOpen, focusFirst: focusFirst };
  }

  /* ------------------------------------------------------------------
     Cart drawer
     Its markup always comes from the cart-drawer section, so the panel
     is replaced rather than patched.
     ------------------------------------------------------------------ */

  var cartDrawer = null;

  function cartDrawerEl() {
    return document.querySelector('[data-cart-drawer]');
  }

  function refreshCartDrawer(markup) {
    var drawer = cartDrawerEl();
    if (!drawer || !markup) return false;

    var parsed = new DOMParser().parseFromString(markup, 'text/html');
    var fresh = parsed.querySelector('[data-drawer-panel]');
    var panel = drawer.querySelector('[data-drawer-panel]');
    if (!fresh || !panel) return false;

    panel.innerHTML = fresh.innerHTML;
    panel.querySelectorAll('[data-qty]').forEach(initQty);
    return true;
  }

  function cartSections() {
    var list = [];
    if (cartDrawerEl()) list.push('cart-drawer');
    var headerId = headerSectionId();
    if (headerId) list.push(headerId);
    return list;
  }

  /* Accepts either a cart or the line item that /cart/add.js returns. Only
     the cart carries item_count, so the header falls back to the section
     markup when it is not there. */
  function applyCartSections(payload) {
    var counted = false;

    if (payload.sections) {
      refreshCartDrawer(payload.sections['cart-drawer']);
      var headerId = headerSectionId();
      var count = headerId ? countFromSectionMarkup(payload.sections[headerId]) : null;
      if (count !== null) {
        setCartCount(count);
        counted = true;
      }
    }

    if (!counted && typeof payload.item_count === 'number') {
      setCartCount(payload.item_count);
      counted = true;
    }

    return counted;
  }

  function initCartDrawerLines(drawer) {
    function change(line, quantity, input) {
      drawer.setAttribute('aria-busy', 'true');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          sections: cartSections().join(','),
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok) throw new Error(json.description || json.message || '');
            return json;
          });
        })
        .then(applyCartSections)
        .catch(function (error) {
          if (input) input.value = input.defaultValue;
          var box = drawer.querySelector('[data-cart-error]');
          if (box) {
            box.textContent = error.message || strings('cartError', 'That change could not be made.');
            box.hidden = false;
          }
        })
        .then(function () {
          drawer.removeAttribute('aria-busy');
        });
    }

    drawer.addEventListener('change', function (event) {
      var input = event.target.closest('[data-qty-input]');
      if (!input) return;
      var group = input.closest('[data-line]');
      if (!group) return;
      change(parseInt(group.getAttribute('data-line'), 10), parseInt(input.value, 10) || 0, input);
    });

    drawer.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-cart-remove]');
      if (!remove) return;
      event.preventDefault();
      change(parseInt(remove.getAttribute('data-cart-remove'), 10), 0, null);
    });
  }

  /* ------------------------------------------------------------------
     Quantity steppers
     ------------------------------------------------------------------ */

  function initQty(root) {
    var input = root.querySelector('[data-qty-input]');
    var down = root.querySelector('[data-qty-down]');
    var up = root.querySelector('[data-qty-up]');
    if (!input || !down || !up) return;

    function step(delta) {
      var min = parseInt(input.getAttribute('min'), 10) || 0;
      var next = (parseInt(input.value, 10) || 0) + delta;
      if (next < min) next = min;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    down.addEventListener('click', function () { step(-1); });
    up.addEventListener('click', function () { step(1); });
  }

  /* ------------------------------------------------------------------
     Product gallery
     ------------------------------------------------------------------ */

  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    var slides = root.querySelectorAll('[data-gallery-slide]');
    if (thumbs.length === 0) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-gallery-thumb');

        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-gallery-slide') === index);
        });

        thumbs.forEach(function (other) {
          other.setAttribute('aria-pressed', other === thumb ? 'true' : 'false');
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Variant selection and add to cart
     ------------------------------------------------------------------ */

  function initProduct(root) {
    var data = document.querySelector('[data-product-variants]');
    var select = root.querySelector('[data-variant-select]');
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!data || !select || !form) return;

    var variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }

    var radios = root.querySelectorAll('[data-option-position]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var unitEl = root.querySelector('[data-unit-price]');
    var priceRoot = root.querySelector('[data-price-root]');
    var button = root.querySelector('[data-atc]');
    var labelEl = root.querySelector('[data-atc-label]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var status = document.querySelector('[data-atc-status]');

    function selectedValues() {
      var chosen = [];
      radios.forEach(function (radio) {
        if (radio.checked) {
          chosen[parseInt(radio.getAttribute('data-option-position'), 10) - 1] = radio.value;
        }
      });
      return chosen;
    }

    function currentVariant() {
      if (radios.length === 0) {
        return variants.filter(function (v) { return String(v.id) === String(select.value); })[0];
      }

      var chosen = selectedValues();
      return variants.filter(function (v) {
        return chosen.every(function (value, i) { return v.options[i] === value; });
      })[0];
    }

    /* Mark each option value: disabled when no variant has it alongside the
       other selected options, sold out when that variant exists but has no
       stock. Sold-out stays selectable so the button can say so. */
    function markOptions() {
      var chosen = selectedValues();

      radios.forEach(function (radio) {
        var position = parseInt(radio.getAttribute('data-option-position'), 10) - 1;
        var candidate = chosen.slice();
        candidate[position] = radio.value;

        var matches = variants.filter(function (v) {
          return candidate.every(function (value, i) {
            return i === position || value === undefined || v.options[i] === value;
          }) && v.options[position] === radio.value;
        });

        var exists = matches.length > 0;
        var available = matches.some(function (v) { return v.available; });

        radio.disabled = !exists;
        radio.setAttribute('data-sold-out', exists && !available ? 'true' : 'false');
      });
    }

    function renderPrice(variant) {
      if (priceEl) priceEl.textContent = money(variant.price);

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.hidden = !onSale;
        if (onSale) {
          compareEl.innerHTML = '';
          var label = document.createElement('span');
          label.className = 'visually-hidden';
          label.textContent = strings('regularPrice', 'Regular price');
          compareEl.appendChild(label);
          compareEl.appendChild(document.createTextNode(money(variant.compare_at_price)));
        }
      }
      if (priceRoot) priceRoot.classList.toggle('price-line--sale', !!onSale);

      if (unitEl) {
        var grams = variant.weight || variant.grams || 0;
        if (grams > 0) {
          var per100 = Math.round(variant.price * 100 / grams);
          unitEl.textContent = strings('per100g', '%s per 100g').replace('%s', money(per100));
          unitEl.hidden = false;
        } else {
          unitEl.hidden = true;
        }
      }
    }

    function refresh() {
      markOptions();

      var variant = currentVariant();
      if (!variant) {
        if (button) {
          button.disabled = true;
          if (labelEl) labelEl.textContent = strings('soldOut', 'Sold out');
        }
        return;
      }

      select.value = variant.id;
      renderPrice(variant);

      if (button) {
        button.disabled = !variant.available;
        if (labelEl) {
          labelEl.textContent = variant.available
            ? strings('addToCart', 'Add to cart')
            : strings('soldOut', 'Sold out');
        }
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        /* history is a convenience, never a requirement */
      }
    }

    radios.forEach(function (radio) { radio.addEventListener('change', refresh); });
    select.addEventListener('change', refresh);
    if (qtyInput) qtyInput.addEventListener('change', refresh);

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var body = new FormData(form);
      var sections = cartSections();
      if (sections.length > 0) {
        body.append('sections', sections.join(','));
        body.append('sections_url', window.location.pathname);
      }

      if (status) status.textContent = '';
      if (button) button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body
      })
        .then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok) throw new Error(json.description || json.message || 'add failed');
            return json;
          });
        })
        .then(function (line) {
          if (applyCartSections(line)) return null;
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (response) { return response.json(); })
            .then(applyCartSections);
        })
        .then(function () {
          /* The drawer is the confirmation when there is one. The inline
             message stays as the fallback for a theme without it. */
          if (cartDrawer) {
            cartDrawer.open();
            return;
          }

          if (status) {
            status.innerHTML = '';
            var text = document.createElement('span');
            text.textContent = strings('added', 'Added to your cart.');
            var link = document.createElement('a');
            link.href = '/cart';
            link.textContent = strings('viewCart', 'View cart');
            status.appendChild(text);
            status.appendChild(link);
          }
        })
        .catch(function (error) {
          if (status) status.textContent = error.message || strings('addError', 'Could not add that to your cart.');
        })
        .then(function () {
          if (button) button.disabled = false;
          refresh();
        });
    });

    refresh();
  }

  /* ------------------------------------------------------------------
     Product recommendations
     ------------------------------------------------------------------ */

  function initRecommendations(root) {
    var url = root.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) root.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* recommendations are non-essential */ });
  }

  /* ------------------------------------------------------------------
     Cart — quantity and removal via section rendering, never a reload.
     A failed change shows Shopify's message and puts the input back.
     ------------------------------------------------------------------ */

  function initCart(root) {
    var sectionId = root.getAttribute('data-cart-section');
    var headerId = headerSectionId();

    function showError(message) {
      var box = root.querySelector('[data-cart-error]');
      if (!box) return;
      box.textContent = message || strings('cartError', 'That change could not be made.');
      box.hidden = false;
    }

    function render(line, quantity, input) {
      root.setAttribute('aria-busy', 'true');

      var sections = headerId ? sectionId + ',' + headerId : sectionId;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          sections: sections,
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok) throw new Error(json.description || json.message || '');
            return json;
          });
        })
        .then(function (cart) {
          var markup = cart.sections && cart.sections[sectionId];
          if (markup) {
            var parsed = new DOMParser().parseFromString(markup, 'text/html');
            var fresh = parsed.querySelector('[data-cart-section]');
            if (fresh) {
              root.innerHTML = fresh.innerHTML;
              root.querySelectorAll('[data-qty]').forEach(initQty);
            }
          }

          var count = headerId && cart.sections ? countFromSectionMarkup(cart.sections[headerId]) : null;
          setCartCount(count !== null ? count : cart.item_count);
        })
        .catch(function (error) {
          if (input) input.value = input.defaultValue;
          showError(error.message);
        })
        .then(function () {
          root.removeAttribute('aria-busy');
        });
    }

    root.addEventListener('change', function (event) {
      var input = event.target.closest('[data-qty-input]');
      if (!input) return;

      var group = input.closest('[data-line]');
      if (!group) return;

      render(parseInt(group.getAttribute('data-line'), 10), parseInt(input.value, 10) || 0, input);
    });

    root.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-cart-remove]');
      if (!remove) return;

      event.preventDefault();
      render(parseInt(remove.getAttribute('data-cart-remove'), 10), 0, null);
    });
  }

  /* ------------------------------------------------------------------
     Predictive search
     Turns the search input into a combobox and fills the results
     container from the predictive-search section. Submit still works.
     ------------------------------------------------------------------ */

  function initPredictive(form) {
    var input = form.querySelector('[data-predictive-input]');
    var results = form.querySelector('[data-predictive-results]');
    var endpoint = form.getAttribute('data-predictive-url');
    if (!input || !results || !endpoint) return;

    var timer = null;
    var lastTerms = '';

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', results.id);
    input.setAttribute('aria-autocomplete', 'list');

    function close() {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    }

    function search(terms) {
      var url = endpoint +
        '?q=' + encodeURIComponent(terms) +
        '&resources[type]=product,article,page' +
        '&resources[limit]=6' +
        '&section_id=predictive-search';

      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          if (terms !== lastTerms) return;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var content = parsed.querySelector('[data-predictive-content]');
          if (!content) {
            close();
            return;
          }
          results.innerHTML = '';
          results.appendChild(content);
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(close);
    }

    input.addEventListener('input', function () {
      var terms = input.value.trim();
      lastTerms = terms;
      clearTimeout(timer);

      if (terms.length < 2) {
        close();
        return;
      }

      timer = setTimeout(function () { search(terms); }, 250);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) close();
    });
  }

  function init() {
    document.querySelectorAll('[data-nav-item]').forEach(initNavItem);

    document.querySelectorAll('[data-drawer]').forEach(function (drawer) {
      var controller = initDrawer(drawer);
      if (drawer.hasAttribute('data-cart-drawer')) {
        cartDrawer = controller;
        initCartDrawerLines(drawer);
      }
    });

    document.querySelectorAll('[data-qty]').forEach(initQty);
    document.querySelectorAll('[data-product-root]').forEach(function (root) {
      initGallery(root);
      initProduct(root);
    });
    document.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
    document.querySelectorAll('[data-cart-section]').forEach(initCart);
    document.querySelectorAll('[data-predictive-form]').forEach(initPredictive);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
